import { SystemLetterInsert, SystemLetterDelete, SystemLetterUpdate, SystemLetterGetById, SystemLetterGetList, SystemLetterGetPageList } from "@/api/systemletter/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    SystemLetterInsert(context, payload) {
        return new Promise((resolve, reject) => {
            
            
            SystemLetterInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    SystemLetterUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            SystemLetterUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    SystemLetterGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            SystemLetterGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    SystemLetterGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            SystemLetterGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    SystemLetterGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            SystemLetterGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}